import React from 'react';
import styled from 'styled-components';
import PillarNumberBadge from './PillarNumberBadge';

export interface BannerTitleProps {
  title: string;
  number: string;
  className?: string;
}

const COLORS = {
  communitiesColor: '#0077a0',
  servicesColor: '#C92E5A',
  neighborhoodsColor: '#116A3C',
  policyColor: '#CC4712',
};

const getPillarColor = (pillarType: string) => {
  switch (pillarType) {
    case 'Services':
      return COLORS.servicesColor;
    case 'Neighborhoods':
      return COLORS.neighborhoodsColor;
    case 'Policies':
      return COLORS.policyColor;
    case 'Communities':
    default:
      return COLORS.communitiesColor;
  }
};

const TitleContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  @media screen and (max-width: 232px) {
    flex-wrap: wrap;
  }
`;

const Header = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
`;

const TitleText = styled.h3<{ pillarType: string }>`
  margin: 0;
  position: relative;
  font-size: inherit;
  font-weight: 700;
  font-family: Montserrat;
  color: ${props => getPillarColor(props.pillarType)};

  @media screen and (max-width: 450px) {
    font-size: 19px;
  }
`;

const BannerTitle: React.FC<BannerTitleProps> = ({
  title,
  number,
  className,
}) => {
  return (
    <TitleContainer className={className}>
      <Header>
        <TitleText pillarType={title}>{title}</TitleText>
        <PillarNumberBadge number={number} pillarType={title} />
      </Header>
    </TitleContainer>
  );
};

export default BannerTitle;
